<template>
  <div v-if="$store.getters['authorization/acl'].hasPermission('campaigns_access')"
       class="PlatformCampaignsView"
  >
    <ShPageHeader title="Kampanie"
                  description="Poniżej znajduje się lista wszystkich kampanii klienta.<br>"
                  :breadcrumb-items="[
                    { label: 'zarządzanie' },
                    { label: 'Kampanie', path: '/campaigns' }
                  ]"
    />
    <ShPageLayout>
      <CampaignsList />
    </ShPageLayout>
  </div>
</template>

<script>
import store from '@/store';
import CampaignsList from '@/components/Campaigns/CampaignsList';

export default {
  name: 'PlatformClients',
  store,
  components: {
    CampaignsList,
  },
};
</script>
